// extracted by mini-css-extract-plugin
module.exports = {"component":"_2z1ldkP2OUq2_gwSfhUA3u","a":"_2jiKWPdHevTCgUTRX7iU0b","small":"_1d5r0YFBMTbhzfN2F7U2W3","light":"_12ABYyPut9GCoy8dfyYCE_"};